import { render, staticRenderFns } from "./DataSourceDatesRangeSelect.vue?vue&type=template&id=b2f51d18"
import script from "./DataSourceDatesRangeSelect.vue?vue&type=script&lang=js"
export * from "./DataSourceDatesRangeSelect.vue?vue&type=script&lang=js"
import style0 from "./DataSourceDatesRangeSelect.vue?vue&type=style&index=0&id=b2f51d18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports